import React from 'react';

const formatTimestamp = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-CA', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

const MessageList = ({ messages = [] }) => {
  if (!messages.length) return null;

  return (
    <div className="flex flex-col gap-y-3">
      {messages.map((m) => (
        <div key={m.id} className="bg-white rounded p-3 border border-gray-200">
          <div className="flex flex-row justify-between text-xs text-slate-500 mb-1">
            <span>{m.author?.name} ({m.author?.role})</span>
            <span>{formatTimestamp(m.created_at)}</span>
          </div>
          <p className="text-sm whitespace-pre-wrap">{m.body}</p>
          {m.files?.length > 0 && (
            <ul className="mt-2 text-xs">
              {m.files.map((f) => (
                <li key={f.id}>
                  <a href={f.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                    {f.filename}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default MessageList;
